import { jsx as _jsx } from "react/jsx-runtime";
import { Typography } from 'seagull';
export const SectionTitle = (param)=>{
    let { variant = 'paragraph1', children } = param;
    return /*#__PURE__*/ _jsx(Typography, {
        variant: variant,
        weight: "normal",
        children: children
    });
};
export const ColorsLabel = (param)=>{
    let { children, skin = 'standard' } = param;
    return /*#__PURE__*/ _jsx(Typography, {
        variant: "paragraph2",
        skin: skin,
        children: children
    });
};
